import { render, staticRenderFns } from "./UpdateAcl.vue?vue&type=template&id=7a5b1529"
import script from "./UpdateAcl.vue?vue&type=script&lang=js"
export * from "./UpdateAcl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports